import { sendRequest } from '@infrastructure/api/api';
import ApiResponse from '@core/types/apiResponse';
import { DepartmentReportQueryParams } from '../types/departmentReport';

export const fetchDepartmentReportStatuses = async (): Promise<ApiResponse<any>> => {
  return await sendRequest<any, any>('GET', `/department/report/status/query?all=1`);
};

export const fetchDepartmentReports = async (
  scope: 'CHURCH' | 'DISTRICT' | 'NATION',
  scopeId: number,
  params: DepartmentReportQueryParams
): Promise<ApiResponse<any>> => {
  const scopePath =
    scope === 'CHURCH' ? `church/${scopeId}` :
    scope === 'DISTRICT' ? `district/${scopeId}` :
    `nation/${scopeId}`;

  const query = new URLSearchParams();
  if (params.reportStatusId) query.set('reportStatusId', String(params.reportStatusId));
  if (params.departmentId) query.set('departmentId', String(params.departmentId));
  if (params.departmentReportId) query.set('departmentReportId', String(params.departmentReportId));
  if (params.reportTagId) query.set('reportTagId', String(params.reportTagId));
  if (params.reportTemplateId) query.set('reportTemplateId', String(params.reportTemplateId));
  if (params.page) query.set('page', String(params.page));
  if (params.perPage) query.set('perPage', String(params.perPage));
  if (params.freetext) query.set('freetext', params.freetext);
  if (params.leadershipType) query.set('leadershipType', params.leadershipType);

  // When a leadership type is supplied, hit the leadership query endpoint (D11 reuse).
  const reportPath = params.leadershipType
    ? 'department/report/leadership/query'
    : 'department/report/query';

  const qs = query.toString();
  return await sendRequest<any, any>('GET', `/${scopePath}/${reportPath}${qs ? `?${qs}` : ''}`);
};
